// plugins/media-query.ts
import { ASS } from "../index.js";
import "./index.js";
var MediaQueryPlugin = class {
  matchModifier(path) {
    return Array.isArray(path) ? path.some((pathPart) => pathPart.startsWith("@media")) : path.startsWith("@media");
  }
  generateFlattenedStyle(pathStyle, flattenedStyle) {
    const queryIndex = pathStyle.path.findIndex((pathPart) => pathPart.startsWith("@media"));
    if (queryIndex !== -1) {
      const query = pathStyle.path.splice(queryIndex, 1)[0];
      if (!flattenedStyle[query])
        flattenedStyle[query] = {};
      flattenedStyle[query][ASS.pathToSelector(pathStyle.path)] = pathStyle.style;
      pathStyle.path = [query, ...pathStyle.path];
    }
    return false;
  }
  generateStyleSheetRule(modifier, styles, sheet) {
    sheet.insertRule(
      `${modifier} { ${Object.keys(styles).map((selector) => ASS.stringifyRule({ [selector]: styles[selector] })).join("\n")} }`,
      sheet.cssRules.length
    );
    return true;
  }
};
export {
  MediaQueryPlugin
};
